import { useAuth } from '@phx-husky/use-auth';

const useProfile = () => {
    const auth = useAuth();
    const validate = (fields) => auth.validate(fields, true);
    return {
        validate,
        getUserName: auth.getUserName,
        getProfileFields: auth.getProfileFields,
        setUserAttributes: auth.setUserAttributes,
        getUserProfileEditRights: auth.getUserProfileEditRights,
        deleteCurrentUser: auth.deleteCurrentUser,
        getUserOrders: auth.getUserOrders,
        createFormattedAddressAttributes: auth.createFormattedAddressAttributes,
        isPasswordProviderUser: auth.isPasswordProviderUser,
        changePassword: auth.changePassword,
        updateUserLegals: auth.updateUserLegals,
        changeEmail: auth.changeEmail,
        verifyCodeForEmailChange: auth.verifyCodeForEmailChange,
    };
};

export { useProfile };
